import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserLanguage } from '../../services/userLanguageService';
import LanguageSwitcherUI from './LanguageSwitcherUI';
import { getLanguageDirection } from '../../i18n/config';

interface LanguageSwitcherProps {
  variant?: 'button' | 'compact';
  showLabel?: boolean;
}

/**
 * Language switcher for authenticated users with database persistence
 */
const LanguageSwitcher: React.FC<LanguageSwitcherProps> = (props) => {
  const { i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';
  const { updateLanguagePreference } = useUserLanguage();

  const handleLanguageChange = async (languageCode: string): Promise<void> => {
    // Change the language in i18n
    await i18n.changeLanguage(languageCode);
    
    // Save to localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('i18nextLng', languageCode);
    }
    
    // Save to database for authenticated users
    await updateLanguagePreference(languageCode);
  };

  return (
    <LanguageSwitcherUI
      {...props}
      onLanguageChange={handleLanguageChange}
    />
  );
};

export default LanguageSwitcher; 
